import {AuthService} from "./AuthService";

export class ProductMatchingService {

    url = `product_matches/`;

    // target: 'competitors' (default, today's behaviour), 'suppliers', or 'both'
    // -- only meaningful while the campaign's supplier module is active.
    matchCompetitorsUsingOtherCodes(campaign_id, target = 'competitors')
    {
        return AuthService.apiPut(this.url + "match_competitors_using_other_codes/", {"campaign_id": campaign_id, "target": target}).then(res => res.data.message);
    }

    matchCompetitorsUsingSelectedFields(campaign_id, selectedFields){
        selectedFields = selectedFields.map(item => item.name)
        return AuthService.apiPut(this.url + "match_competitors_using_selected_fields/", {"campaign_id": campaign_id, "selected_fields": selectedFields}).then(res => res.data.data);
    }

    // Site-based matching: match_fields_based_url = { url: {selected, fields:[{name}]} }.
    // url=null processes every selected site; a specific url only that host.
    matchCompetitorsUsingMatchFields(campaign_id, match_fields_based_url, url = null){
        return AuthService.apiPut(this.url + "match_competitors_using_match_fields/",
            {"campaign_id": campaign_id, "match_fields_based_url": match_fields_based_url, "url": url}).then(res => res.data.data);
    }

    // Copy competitors from a source ("catalog") campaign's products onto
    // code-matched products in the target campaign.
    matchProductsFromOtherCampaign(to_campaign_id, from_campaign_id, included_owner = false){
        return AuthService.apiPut(this.url + "match_products_from_other_campaign/",
            {"to_campaign_id": to_campaign_id, "from_campaign_id": from_campaign_id, "included_owner": included_owner}).then(res => res.data);
    }

    // Bulk match or unmatch undecided suggestions by score threshold (optionally per domain).
    // action: 'match' | 'unmatch'. dry_run=true returns count only.
    bulkMatchUnmatchByScore(campaignId, minMatchScore, action, domains, dryRun) {
        return AuthService.apiPut(this.url + "bulk_match_unmatch_by_score/",
            {campaign_id: campaignId, min_match_score: minMatchScore, action: action, domains: domains, dry_run: dryRun})
            .then(res => res.data.data);
    }
}
